<!-- <p>bundle-spec works!</p> -->

<kt-portlet>

	<!-- <kt-portlet-header [sticky]="true" [title]="'Machine List'" [class]="'kt-portlet__head--lg'" [viewLoading$]="dataSource.loading$"> -->

	<!-- </kt-portlet-header> -->
	<!-- end::Header -->

	<kt-portlet-body>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<div class="hierarchical-filters">
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select UI</label>
					<kt-searchable-select
						[options]="uiVersionOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="selectedUI"
						(selectionChange)="UIChanged($event)">
					</kt-searchable-select>
				</div>
			</div>
			<!-- end::FILTERS -->
		</div>

		<!-- end::FILTERS & GROUP ACTIONS -->

<!-- Bundle Spec -->

  <!-- <div class="main-div">
	<div *ngIf="selectedUI" class="table-container">
	  <table mat-table [dataSource]="tableData" class="mat-table-no-border">
		<ng-container matColumnDef="key">
		  <td mat-cell *matCellDef="let element" class="text-main"> {{ element[0] }} </td>
		</ng-container>
		<ng-container matColumnDef="value">
		  <td mat-cell *matCellDef="let element"> {{ element[1] }} </td>
		</ng-container>

		<tr mat-row *matRowDef="let row; columns: ['key', 'value']"></tr>
	  </table>
	</div>
  </div> -->

  <div  class="row justify-content-center mb-5">
	<div class="col-xl-5">
		<div class="row mt-2">
			<div class="col-4 text-dark"><b>UI</b> </div>
			<div class="col-7">: <span *ngIf="selectedUI">{{selectedUI}}</span></div>
		</div>
		<div class="row mt-5">
			<div class="col-4 text-dark"><b>Menu</b></div>
			<div class="col-7">:
				<mat-chip-list *ngIf="bundSpec && bundSpec.menu">
					<mat-chip style="margin-top:-20px;margin-left:10px" color="primary" (click)="deleteFile(deleteConfirm, { type: 'MENU', value: bundSpec.menu })">
						{{ bundSpec.menu || NULL}}
						<mat-icon matChipRemove style="color: red;" (click)="deleteFile(deleteConfirm,{ type: 'MENU', value: bundSpec.menu })">remove_circle</mat-icon>
					  </mat-chip>
				</mat-chip-list>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-4 text-dark"><b>Aux</b></div>
			<div class="col-7">:
				<!-- {{bundSpec.aux}} -->
				<mat-chip-list *ngIf="bundSpec && bundSpec.aux">
					<mat-chip style="margin-top:-20px;margin-left:10px" color="primary" (click)="deleteFile(deleteConfirm, { type: 'AUX', value: bundSpec.aux })">
						{{ bundSpec.aux || NULL}}
						<mat-icon matChipRemove style="color: red;" (click)="deleteFile(deleteConfirm,{ type: 'AUX', value: bundSpec.aux })">remove_circle</mat-icon>
					  </mat-chip>
				  </mat-chip-list>
			</div>
		</div>
	</div>
  </div>

  <!-- <div class="main-div">
	<div *ngIf="selectedUI" class="table-container">
	  <table mat-table [dataSource]="tableData" class="mat-table-no-border">
		<ng-container matColumnDef="key">
		  <td mat-cell *matCellDef="let element" class="text-main"> {{ element[0] }} </td>
		</ng-container>


		<ng-container matColumnDef="value">
		  <td mat-cell *matCellDef="let element">
			<ng-container *ngIf="element[0] === 'Menu' || element[0] === 'AUX'">
			  <ng-container *ngIf="element[1] !== 'NULL'">
				<mat-chip-list>
					<mat-chip color="primary" (click)="deleteFile(deleteConfirm, { type: element[0], value: element[1] })">
						{{ element[1]}}
						<mat-icon matChipRemove style="color: red;" (click)="deleteFile(deleteConfirm,{ type: element[0], value: element[1] })">remove_circle</mat-icon>
					  </mat-chip>
				  </mat-chip-list>
			  </ng-container>
			  <ng-container *ngIf="element[1] == 'NULL'">
				{{ element[1] }}
			  </ng-container>
			</ng-container>
			<ng-container *ngIf="element[0] !== 'Menu' && element[0] !== 'AUX'">
			  {{ element[1] }}
			</ng-container>
		  </td>
		</ng-container>

		<tr mat-row *matRowDef="let row; columns: ['key', 'value']"></tr>
	  </table>
	</div>
  </div> -->


<!-- Bundle Spec Ends -->

		<div class="kt-form kt-margin-b-30" *ngIf="selectedUI">
			<!-- start::FILTERS -->
			<div class="hierarchical-filters">
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select type</label>
					<kt-searchable-select
						[options]="typeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="typeSelected"
						(selectionChange)="typeChanged($event)">
					</kt-searchable-select>
				</div>
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select mode</label>
					<kt-searchable-select
						[options]="modeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="modeSelected"
						(selectionChange)="modeChanged($event)">
					</kt-searchable-select>
				</div>
			</div>
			<!-- end::FILTERS -->

			<div class="mat-table__wrapper">

				<mat-table class="lmat-elevation-z8"
					#table
					[dataSource]="dataSource"
					matSort
					matSortActive="uploaded_at"
					matSortDirection="desc"
					matSortDisableClear>

					<ng-container matColumnDef="file_version">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
						<mat-cell *matCellDef="let file">
							{{file.file_version}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="file_desc">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
						<mat-cell *matCellDef="let file">{{file.file_desc}}</mat-cell>
					</ng-container>



					<ng-container matColumnDef="file_name">
						<mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
						<mat-cell *matCellDef="let file">{{file.file_name}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="actions">
						<mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
						<mat-cell *matCellDef="let file">
							<button (click)="assign(file)" color="primary" mat-icon-button matTooltip="Assign">
								<mat-icon class="mat-danger-text">send</mat-icon>
							</button>&nbsp;

						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
				</mat-table>

				<div class="mat-table__message" *ngIf="((!modeSelected || modeSelected.length === 0) || (!typeSelected || typeSelected.length === 0))">Please Select File Type and Mode</div>
				<div class="mat-table__message" *ngIf="(dataSource.loading$ | async)">Please wait....</div>
				<div class="mat-table__message" *ngIf="dataSource.empty">No records found</div>
			</div>
		</div>



		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>
</kt-portlet>

 <!-- Delete Confirmation PopUP -->
<ng-template #deleteConfirm let-c="close" let-d="dismiss">
	<div class="modal-body text-center">
		<br>
		Do you want to delete?
		<br>
		<br>
		<div class="text-center">
			<button mat-raised-button  (click)="c('close')">Cancel</button> &nbsp;
			<button mat-raised-button class="mat-danger" (click)="c('delete')" color="primary">Delete</button>
		</div>
	</div>
</ng-template>




